module.exports = __webpack_public_path__ + "static/media/ggmap.47e515f0.png";